export default __webpack_public_path__ + "static/blob-33-f92b189b6409152758def3f485656bff.svg";